import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import {User} from '../../shared/model/user';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AddUserRequest} from '../../shared/model/request/add-user-request';
import {UpdateUserRequest} from '../../shared/model/request/update-user-request';

@Injectable()
export class UserAdminService {

  constructor(public _http: HttpClient) { }


  /**
   * Get a single user by his id
   * @param {number} id The user's id
   * @returns {Observable<User>}
   */
  getUser(id: number): Observable<User> {
    return new Observable<User>((subscriber: Subscriber<User>) => {
      this._http.get(environment.endpoints.clientBaseUrl + environment.endpoints.getUser.replace('{id}', String(id)))
        .subscribe(
          (response: User) => {
            subscriber.next(response);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  /**
   * Get all users
   * @returns {Observable<User[]>}
   */
  getUsers(): Observable<User[]> {
    return new Observable<User[]>((subscriber: Subscriber<User[]>) => {
      this._http.get(environment.endpoints.clientBaseUrl + environment.endpoints.userList)
        .subscribe(
          (response: User[]) => {
            subscriber.next(response);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  /**
   * Create a new user
   * @param {User} user The user object
   * @returns {Observable<string>}
   */
  addUser(user: User): Observable<string> {
    const body: AddUserRequest = {
      username: user.username,
      name: user.username.split('@')[0],
      password: user.password,
      authorities: user.authorities,
      enabled: user.enabled
    };

    return new Observable<string>((subscriber: Subscriber<string>) => {
      this._http.post(environment.endpoints.clientBaseUrl + environment.endpoints.addUser, body)
        .subscribe(
          (response: string) => {
            subscriber.next(response);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  /**
   * Update a single user
   * @param {User} user The updated user
   * @returns {Observable<string>}
   */
  updateUser(user: User): Observable<string> {
    const authoritiesStringArr: string[] = [];

    // authorities as a string array
    for (let i = 0; i < user.authorities.length; i++) {
      authoritiesStringArr.push(user.authorities[i].authority);
    }

    const body: UpdateUserRequest = {
      id: user.id,
      username: user.username,
      name: user.username.split('@')[0],
      password: user.password,
      authorities: authoritiesStringArr,
      enabled: user.enabled
    };

    return new Observable<string>((subscriber: Subscriber<string>) => {
      this._http.put(environment.endpoints.clientBaseUrl + environment.endpoints.updateUser, body)
        .subscribe(
          (response: string) => {
            subscriber.next(response);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

}
